import { NavLink } from "react-router";
import { ExternalLink } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { AhuDataOwner } from "./use-ahu-data-owner";

/**
 * AhuDataOwnerButton leads to the document owning the ahu data.
 */
export function AhuDataOwnerButton({ owner }: { owner: AhuDataOwner }) {
  return (
    <Button asChild variant="outline" size="sm">
      <NavLink to={owner.path}>
        <ExternalLink />
        {owner.label}
      </NavLink>
    </Button>
  );
}
